module.exports = __webpack_public_path__ + "img/more.6523c6c0.svg";